import React from 'react';
import PropTypes from 'prop-types';

import Menu from '@mui/icons-material/Menu';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';

import PermissionsContext from '../contexts/PermissionsContext.jsx';
import ProfileDropdown from './ProfileDropdown.jsx';

function TopBar({ onClick }) {
  const ultraNarrow = useMediaQuery('(max-width:399px)');
  const { permissions } = React.useContext(PermissionsContext);
  const hasPermissions = permissions && permissions.length > 0;

  return (
    <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Stack
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: 3,
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {hasPermissions && (
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="menu"
                onClick={onClick}
              >
                <Menu data-cy="menu-button" />
              </IconButton>
            )}
            <img src="/favicon.ico" alt="TZ" height="32px" />
          </Box>

          {!ultraNarrow && <ProfileDropdown />}
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default TopBar;

TopBar.propTypes = {
  onClick: PropTypes.func,
};
